'use client';
import { rem } from '@s7/styles';

const getCircularVariantSizes = ({ height })=>{
    return {
        height: height ? rem(height) : 'auto',
        width: height ? rem(height) : '100%',
        borderRadius: '50%'
    };
};

export { getCircularVariantSizes };
//# sourceMappingURL=getCircularVariantSizes.js.map
